import { createElementBlock as e, openBlock as t, renderSlot as n } from "vue";
import r from "./index231.js";
const s = {}, c = {
  class: "font-bold",
  "data-component": "MsBold"
};
function l(o, a) {
  return t(), e("span", c, [
    n(o.$slots, "default")
  ]);
}
const _ = /* @__PURE__ */ r(s, [["render", l]]);
export {
  _ as default
};
